import React, { ComponentType } from 'react';
import TranslateService from './service';

const withTranslation = () => (Comp: ComponentType) => (props: any) => (
  <Comp t={TranslateService.t} {...props} />
);

export default withTranslation;
